// Types
import {
  ReviewTemplateType,
  ReviewTemplateErrorType,
  //   ReviewTemplateErrorType,
  //   ReviewTemplateQuestionErrorType,
} from 'Shared/types/ReviewTemplates.type';

import { getReviewFormTemplateQuestionErrors, getReviewFormTemplateErrors } from './ReviewFormTemplate.utils';

export const getReviewTemplateErrors = ({
  reviewTemplate,
}: {
  reviewTemplate: ReviewTemplateType;
}): ReviewTemplateErrorType[] => {
  if (!reviewTemplate) return [];

  let errors: ReviewTemplateErrorType[] = [];

  errors = reviewTemplate.reviewFormTemplates
    .map(rft => {
      const reviewFormTemplateErrors = getReviewFormTemplateErrors({ reviewFormTemplate: rft });
      const reviewFormTemplateQuestionErrors = getReviewFormTemplateQuestionErrors({ reviewFormTemplate: rft });
      return [...reviewFormTemplateQuestionErrors, ...reviewFormTemplateErrors];
    })
    .flat();

  return errors.filter(e => e);
};
